import {
  Backdrop,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import dayjs from 'dayjs';
import { othListEwayHeads } from './data';
import { axiosInstanceForLambda } from '../../../library/Axios';
import API_ENDPOINTS from '../../../apiEndpoints';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { useNavigate } from 'react-router-dom';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useState } from 'react';
import DeleteModal from '../../../components/modals/DeleteModal';
import { useDispatch, useSelector } from 'react-redux';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../../redux/reducers/eInvReducer';

dayjs.extend(customParseFormat);
const OtherDataTable = ({ data, setData, storage }) => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [rejectData, setRejectData] = useState({});

  const navigate = useNavigate();
  function isGreaterThan72Hours(dateStr) {
    // Convert "08/04/2025 04:39:00 PM" to a dayjs object
    const inputDate = dayjs(dateStr, 'DD/MM/YYYY hh:mm:ss A');
    console.log(inputDate, 'inputDate');
    // Get current time
    const now = dayjs();

    // Get the difference in hours
    const diffInHours = now.diff(inputDate, 'hour');
    console.log(diffInHours, 'diffInHours');
    return diffInHours <= 72;
  }
  console.log(data, 'data');
  const dispatch = useDispatch();
  let prevData = useSelector((state) => state.eInvReducer.data);
  const eWayReject = async (ewaybill) => {
    setBackdropOpen(true);
    const payload = {
      action: 'REJEWB',
      // credentials: {
      //   userName: "AL001",
      //   password: "Alankit@123",
      //   Gstin: "07AGAPA5363L002",
      //   // userName: "Matrix2050",
      //   // password: "Matrix@2050",
      //   // Gstin: "33AAHCS2907G1ZK",
      // },
      data: {
        ewbNo: ewaybill,
      },
      ...(Object.keys(prevData).length > 0 ? { credentials: prevData } : null),
    };

    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
      console.log(res, 'res');
      if (res.status === 200) {
        showSuccessSnackbar('Eway bill successfully rejected');
        setData((prev) => prev.map((item) => (item.ewbNo === ewaybill ? { ...item, rejectStatus: 'Y' } : item)));
      }
    } catch (error) {
      console.log(error, 'error');
      const filteredArray = error.response.data?.details.filter((item) => item !== null);
      const formatted =
        filteredArray?.length === 1
          ? error.response.data?.details[0]?.errorDesc + '.'
          : filteredArray?.length > 1
          ? filteredArray
              .map((item, index) => {
                if (index === filteredArray.length - 1) return item.errorDesc + '.';
                return item.errorDesc + ',';
              })
              .join(' ')
          : error.response.data.message
          ? error.response.data.message
          : '';

      const errorMessage = formatted ? formatted : error.response.statusText;

      showWarningSnackbar(errorMessage);
    } finally {
      setBackdropOpen(false);
      dispatch(einvAuthData({}));
      dispatch(einvAuth(false));
      dispatch(einvPreview({ preview: false, id: 0 }));
      dispatch(einvId(false));
      // setFormData(extendFormInitialData);
      // setErrFormData(extendErrFormInitialData);
    }
  };
  return (
    <TableContainer sx={{ marginTop: 3 }}>
      <Table
        stickyHeader
        aria-label="sticky table"
        sx={{
          borderRadius: 2,
        }}
      >
        <TableHead>
          <TableRow>
            {othListEwayHeads.map((data) => (
              <TableCell
                align={data.align}
                sx={{
                  color: '#FFF',
                  backgroundColor: 'primary.main',
                  fontFamily: 'overpass',
                  fontSize: 14,
                  fontWeight: 'bold',
                  minWidth: data.width,
                  padding: ' 1px',
                  paddingLeft: data.id === 'sl' ? '20px' : '3px',
                  paddingRight: data.id === 'action' ? '20px' : '3px',
                }}
              >
                {data.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((dat, i) => {
              const status = dat?.rejectStatus === 'Y' ? 'Rejected' : dat?.status === 'CNL' ? 'Cancelled' : 'Active';
              const rejectBtn = isGreaterThan72Hours(dat?.ewayBillDate);

              return (
                <TableRow
                  onClick={() => {
                    navigate('/addewaybill', {
                      state: { data: dat },
                    });
                    localStorage.setItem('singleOthewayData', JSON.stringify(storage));
                  }}
                  className="noTableCellBorder"
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell sx={{ padding: ' 5px' }} align="center">
                    {i + 1}
                  </TableCell>
                  <TableCell sx={{ padding: ' 5px' }} align="left">
                    {dat.ewbNo}
                  </TableCell>
                  <TableCell sx={{ padding: ' 5px' }} align="left">
                    {dat?.ewayBillDate}
                  </TableCell>
                  <TableCell sx={{ padding: ' 5px' }} align="left">
                    {status}
                  </TableCell>
                  <TableCell align="left" sx={{ maxWidth: '150px', padding: ' 1px' }}>
                    <Tooltip title={dat.toTradeName} placement="right">
                      <span
                        style={{
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {dat.fromTradeName}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell sx={{ padding: ' 5px' }} align="left">
                    {dat?.fromGstin}
                  </TableCell>
                  <TableCell sx={{ padding: ' 5px' }} align="left">
                    {dat.docNo}
                  </TableCell>
                  <TableCell sx={{ padding: ' 5px' }} align="left">
                    {dat?.docDate}
                  </TableCell>
                  <TableCell sx={{ padding: '10px 30px' }} align="right">
                    {dat.totInvValue}
                  </TableCell>
                  <TableCell sx={{ padding: ' 5px' }} align="left">
                    {dat.rejectStatus === 'Y' ? (
                      'Rejected '
                    ) : rejectBtn === true ? (
                      <Button
                        sx={{
                          backgroundColor: 'red',
                          color: 'white',
                          '&:hover': { backgroundColor: 'red' },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setRejectData(dat);
                          setDeleteModal(true);
                        }}
                      >
                        Reject
                      </Button>
                    ) : (
                      status
                    )}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell height={'400'} align="center" colSpan={9} sx={{ border: 'none' }}>
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {deleteModal && (
        <DeleteModal
          open={deleteModal}
          setOpen={setDeleteModal}
          setFn={() => {
            setDeleteModal(false);
            // setNewSetting(false);
          }}
          func={(e) => {
            e.stopPropagation();
            eWayReject(rejectData.ewbNo);
            setRejectData({});
            setDeleteModal(false);
          }}
          text={'E way bill'}
          text2="reject"
        />
      )}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </TableContainer>
  );
};

export default OtherDataTable;
